import {
  ARTICLE_PAGE_SCHEMA,
  getBreadCrumbSchema,
} from '../../../constants/componentStaticData';
import {
  LANGUAGE_ENUMS,
  LANGUAGE_VALUE,
  TLANGUAGE_VALUE,
  domainCode,
} from '../../../constants/staticPageConstants';
import { Meta } from '../../../layout/Meta';
import { Breadcrumb } from '../../Atoms/BreadCrumb';
import { DOMAIN_HOST_URL_PREFIX } from '../../Author/constants';
import { CMSHeader } from '../../cms/layout/components';
import { GLOSSARY_PAGE_PROPS } from '../../cms/layout/types';
import {
  getBreadCrumbDataWithDomain,
  getGlossaryBreadCrumbData,
} from '../../cms/layout/util';
import { ScrollTopButton } from '../../glossary/components/ScrollTopButton';
import TopCTABanner from '../../glossary/components/TopCTABannerITR';
import { ArticleContent } from './Article/ArticleContent';
import { Search } from './Search';
import { Trending } from './Trending';

const GlossaryTerms = ({ postData }: GLOSSARY_PAGE_PROPS): JSX.Element => {
  const { title, permalink, keywords, description } = postData?.data || {
    title: '',
    permalink: '',
  };
  const { data } = postData;

  const BREADCRUMB_DATA = getGlossaryBreadCrumbData(data, 'English');
  const BREADCRUMB_DATA_DOMAIN = getBreadCrumbDataWithDomain(data, 'English');
  const LANGUAGE = LANGUAGE_VALUE[
    data?.language as TLANGUAGE_VALUE
  ] as LANGUAGE_ENUMS;
  const castCategory = {
    slug: 'business',
    parent: null,
    name: 'Business',
    id: 1,
    domain: data.domain,
    status: true,
  };
  const metaTitle = `${title} - Definition, What is ${title}, Advantages of ${title}, and Latest News - ClearTax`;
  const metaDescription = `The term ${title} is a core concept under trading. Get to know the definition of ${title}, what it is, the advantages, and the latest trends here.`;
  return (
    <div className="article">
      <CMSHeader
        domain={data.domain}
        category={castCategory}
        language={LANGUAGE}
        isMultiLang={data.multi_language}
        permalink={data.permalink}
      />
      {/* <InternationalNavBar theme={THEME.dark} /> */}
      <Meta
        title={`${data.meta_title ? data.meta_title : metaTitle}`}
        description={`${data.description ? data.description : metaDescription}`}
        canonical={`${DOMAIN_HOST_URL_PREFIX}/glossary/${permalink}`}
      />
      <TopCTABanner
        bannerLink={
          'https://cleartax.in/filing?utm_ref=itr_2025_organic_topcta_deadline'
        }
      />
      <div className="pl-24 sm:pl-6 pr-6 py-12 mx-auto sm:py-2">
        <ScrollTopButton />

        <Breadcrumb className="mt-4 sm:mt-0" dataSet={BREADCRUMB_DATA} />
        <Search domainVal={domainCode.cleartaxIn} />
        <Trending domainVal={domainCode.cleartaxIn} />
        <ArticleContent articleData={postData?.data} />
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(getBreadCrumbSchema(BREADCRUMB_DATA_DOMAIN)),
        }}
      ></script>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            ARTICLE_PAGE_SCHEMA({
              title: title,
              metaDesc: description,
              productType: 'itr',
              keywords: keywords,
              url: `${DOMAIN_HOST_URL_PREFIX}/glossary/${permalink}`,
            })
          ),
        }}
      ></script>
    </div>
  );
};

export default GlossaryTerms;
